import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { Box } from "@mui/system";
import { ArrayNumberColorChip } from "components/Chip/ArrayNumberColorChip";
import { dateTimeFormat } from "constants/componentsConstants";
import { IndicatorColorRange } from "constants/indicatorConstants";
import dayjs from "configs/dayjs.config";

import { getAlertColorFromCriticalFlag } from "pages/Dashboards/ProjectViewer/util/util";
import { useEffect, useState } from "react";

export const ProjectTaskMeta = ({ row }) => {
  const [criticalTextColor, setCriticalTextColorTextColor] = useState("");
  useEffect(() => {
    setCriticalTextColorTextColor(
      getAlertColorFromCriticalFlag(row.isCritical)
    );
  }, []);
  return (
    <TableContainer content={Box}>
      <Table
        size="small"
        sx={{
          "& .MuiTableCell-root": {
            borderBottom: "none",
            color: criticalTextColor,
          },
        }}
      >
        <TableBody>
          <TableRow>
            <TableCell>
              {row.projectCode} : {row.projectName}
            </TableCell>
            <TableCell align="right">
              <ArrayNumberColorChip
                list={[
                  {
                    value:
                      (row?.products?.length || 0) - (row.statusCritical || 0),
                    color: IndicatorColorRange.veryLow,
                  },
                  {
                    value: Number(row.statusCritical || 0),
                    color: IndicatorColorRange.veryHigh,
                  },
                  {
                    value: Number(row?.products?.length || 0),
                    color: "",
                  },
                ]}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              Project DL :
              {dayjs(row.projectDeadline).format(dateTimeFormat.date)}
            </TableCell>
            <TableCell align="right">
              Min DL :
              {row.minDeadline
                ? dayjs(row.minDeadline).format(dateTimeFormat.date)
                : "-"}
              {" / "}Max DL :
              {row.maxDeadline
                ? dayjs(row.maxDeadline).format(dateTimeFormat.date)
                : "-"}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
